<div class="font-poppins">
    <nz-card *ngIf="!updateMode">
        <div class="row m-b-30 d">
            <div class="col-lg-7">
                <div class="d-md-flex">
                    <!-- <div *ngIf="iconVisible" class="m-b-10 m-r-20">
                        <button title="Go Back" (click)="closeDetail()" nz-button nzType="default">
                            <i nz-icon nzType="arrow-left" nzTheme="outline"></i>
                        </button>
                    </div> -->
                    <div class="m-b-10 m-r-20">
                        <nz-input-group [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate">
                            <input type="text" nz-input placeholder="Search" 
                                [(ngModel)]="searchTerm" #searchBox />
                                <!-- (keyup)="onKeyUp(searchBox.value)" -->
                        </nz-input-group>
                        <ng-template #suffixTemplate>
                            <a nz-icon class="opacity-05" (click)="resetSearch()">
                                <i nz-icon nzType="close" class="opacity-05"></i>
                            </a>
                        </ng-template>
                        <ng-template #prefixTemplate>
                            <i nz-icon nzType="search" class="opacity-05"></i>
                        </ng-template>
                    </div>

                    <div class="m-b-10 m-r-10">
                        <button class="btn-fill" nz-button nzType="default" nzSize="small"
                            (click)="applySearch(searchTerm)" [nzDisabled]="isLoading || !searchTerm">
                            Search
                        </button>
                    </div>

                    <div class="m-b-10 m-r-10">
                        <button nz-button nz-popover [nzPopoverContent]="popoverContent" nzPopoverTrigger="click"
                            nzPopoverPlacement="bottom" [(nzPopoverVisible)]="filterVisible"
                            (nzPopoverVisibleChange)="onPopoverVisibleChange($event)" class="btn-outline resource-btn"
                            style="text-align: center">

                            <span *ngIf="!this.isArchived">All Active Users</span>
                            <span *ngIf="this.isArchived">Archived</span>
                            <i nz-icon nzType="caret-down" style="position: relative; top: 1px; left: -3px"
                                nzTheme="outline"></i>
                        </button>
                        <ng-template class="filter" style="text-align: left; padding: 0px !important" #popoverContent>
                            <div class="">
                                <div nz-row nzGutter="24" style="padding-top: 10px;">
                                    <div nz-col class="gutter-row" nzSpan="24" style="padding-bottom: 15px">
                                        <span class="filter-heading">Show users that are</span>
                                    </div>
                                </div>
                            </div>
                            <div style="height: 40px" nz-row>
                                <div style="color: #2d2d35; font-family: Poppins !important" nz-col nzSpan="24">

                                    <label nz-checkbox [(ngModel)]="archived">Archived</label>
                                </div>
                            </div>
                            <div nz-row>
                                <div nz-col nzSpan="24" class="d-flex align-items-center justify-content-between">
                                    <span (click)="clickFilter()" class="cancel-label">Cancel</span>
                                    <button class="btn-fill" nz-button nzType="default" nzSize="small"
                                        (click)="applyFilters()">
                                        Apply
                                    </button>
                                </div>
                            </div>
                        </ng-template>
                    </div>

                </div>
            </div>
            <div class="col-lg-5">
                <div class="d-md-flex justify-content-end">
                    <button nz-button="" nztype=" primary" class="font-small-caps btn-custom-light" title="Delete"
                        *ngIf="anyChecked" 
                        (click)="openDeleteModal(null, true)"
                        style="margin-right: 10px" [nzLoading]="isLoading">
                        <i class="font-size-16" nz-icon nzType="delete" theme="fill"></i>
                    </button>
                    
                </div>
            </div>
        </div>

        <div class="row">
            <nz-spin [nzSpinning]="isLoading" nzTip="Loading...">
                <div #scrollContainer 
                    class="table-wrapper" 
                    infiniteScroll 
                    [infiniteScrollDistance]="1"
                    [infiniteScrollThrottle]="150"
                    scrollWindow="false"
                    style="height: calc(100vh - 170px); overflow-y: auto; overflow-x: hidden !important;"
                    (scroll)="onScroll($event)">
                    <nz-table 
                        [nzScroll]="{ x: '100%' }" 
                         #userTable 
                        [nzData]="userData" 
                        [nzShowPagination]="false"
                        [nzFrontPagination]="false"
                        [class.table-disabled]="this.isArchived"
                    >
                    <!-- [nzPageSize]="20"
                    [nzLoading]="showLoad" -->
                        <thead>
                            <tr>
                                <th nzWidth="60px" nzShowCheckbox [(nzChecked)]="allChecked" (nzCheckedChange)="checkAll($event)"
                                    [nzDisabled]="this.isArchived"></th>
                                <ng-container *ngFor="let column of listOfColumns">
                                    <th *ngIf="column.name !== ''"
                                        [hidden]="column.name === 'Actions' && this.isArchived"
                                        [nzSortOrder]="column.sortOrder" [nzSortFn]="column.sortFn"
                                        [nzSortDirections]="column.sortDirections"
                                        [nzFilterMultiple]="column.filterMultiple" [nzWidth]="column.colWidth">
                                        {{ column.name }}
                                    </th>
                                    <th *ngIf="column.name === ''">{{ column.name }}</th>
                                </ng-container>

                            </tr>
                        </thead>
                        <tbody [@fadeIn]>
                            <tr *ngFor="let data of userTable.data" class="data-row table-row cursor-move"
                                [ngStyle]="{'opacity': this.isArchived ? '0.7' : '1'}">
                                <ng-container>
                                    <td nzShowCheckbox [(nzChecked)]="data.checked" (nzCheckedChange)="refreshStatus()"
                                        [nzDisabled]="this.isArchived"></td>

                                    <td (click)="fillUserForm(data)" [nzDisabled]="this.isArchived">
                                        <div class="d-flex align-items-center">
                                            <nz-avatar [nzSize]="30" nzIcon="user"
                                                [nzSrc]="data.image_path"></nz-avatar>
                                            <span class="m-l-10 m-b-0 ">{{ data.first_name}}</span>
                                        </div>
                                    </td>
                                    <!-- <td (click)="fillUserForm(data)">
                                            <div class="d-flex align-items-center">
                                                <span class="m-b-0">{{ data.last_name }}</span>
                                            </div>
                                        </td> -->
                                    <!-- <td (click)="fillUserForm(data)">
                                            <div class="d-flex align-items-center">
                                                <span class="m-b-0">{{ data.role_name }}</span>
                                            </div>
                                        </td> -->

                                    <td (click)="fillUserForm(data)" [nzDisabled]="this.isArchived">
                                        <ng-container *ngIf="data.roles && data.roles.length > 0">
                                            <ng-container *ngIf="data.roles.length <= 2; else moreTags">
                                                <nz-tag *ngFor="let role of data.roles.slice(0, 2)" [nzMode]="default"
                                                    [nzColor]="'#ededed'">
                                                    {{ role.role_name }}
                                                </nz-tag>
                                            </ng-container>
                                            <ng-template #moreTags>
                                                <span *ngFor="let role of data.roles.slice(0, 2)">
                                                    <nz-tag [nzMode]="default" [nzColor]="'#ededed'">{{
                                                        role.role_name
                                                        }}</nz-tag>
                                                </span>

                                                <span nz-popover [nzPopoverContent]="moreContents"
                                                    nzPopoverPlacement="bottom"
                                                    (mouseenter)="updateMoreTagsContent(data.roles)"
                                                    (mouseleave)="resetMoreTagsContent()">
                                                    <nz-tag [nzMode]="default" [nzColor]="'#ededed'">+{{
                                                        data.roles.length
                                                        - 2 }} more</nz-tag>
                                                </span>

                                                <ng-template #moreContents>
                                                    <span *ngFor="let role of moreTagsContent">
                                                        <nz-tag [nzMode]="default" [nzColor]="'#ededed'">{{ role
                                                            }}</nz-tag>
                                                    </span>
                                                </ng-template>
                                            </ng-template>
                                        </ng-container>
                                    </td>

                                    <td (click)="fillUserForm(data)" [nzDisabled]="this.isArchived">
                                        <div class="d-flex align-items-center">
                                            <span class="m-b-0">{{ data.phone_number }}</span>
                                        </div>
                                    </td>
                                    <td (click)="fillUserForm(data)" [nzDisabled]="this.isArchived">
                                        <div class="d-flex align-items-center">
                                            <span class="m-b-0">{{ data.last_updated | timezoneDate:currentBrowserTimeZone }}</span>
                                        </div>
                                    </td>
                                    <td *ngIf="!this.isArchived" class="row-action">

                                        <!-- <span class=""> -->
                                            <button 
                                            nz-button 
                                            nzType="default" 
                                            nzShape="circle" 
                                            nz-tooltip
                                            nzTooltipTitle="Delete" 
                                            (click)="openDeleteModal(data.user_id)"
                                            class="delete-btn"
                                            >
                                                <i 
                                                nz-icon 
                                                nzType="delete" 
                                                theme="outline"></i>
                                            </button>
                                      
                                      
                                    </td>


                                </ng-container>
                            </tr>
                        </tbody>
                    </nz-table>
                        <!-- Delete confirmation modal -->
                        <nz-modal [(nzVisible)]="isDeleteModalVisible" nzTitle="Confirm User(s) Deletion ?" [nzFooter]="deleteModalFooter"
                            (nzOnCancel)="handleDeleteCancel()" [nzMask]="true">
                            <ng-container *nzModalContent class="popup-body">
                                <!-- <div class="mb-2 text-black" *ngIf="checkedData.length > 1">
                                    Selected users <strong class="text-danger">{{checkedData.length}}</strong>
                                
                                </div> -->
                                <div class="text-black font-semibold ">
                                    <i nz-icon nzType="warning" theme="outline"></i> This action will permanently delete the selected user(s) and all associated data. This cannot be undone.
                                </div>
                               
                                
                               
                                <div class="mt-3 text-black">
                                    To confirm, please type <strong>DELETE</strong> in the text input field.
                                </div>

                        
                                <input nz-input type="text" placeholder="Type DELETE here" [(ngModel)]="deleteConfirmationText" class="mt-3" />
                            </ng-container>
                        
                            <ng-template #deleteModalFooter>
                                <button nz-button nzType="default" (click)="handleDeleteCancel()">Cancel</button>
                                <button nz-button nzType="primary" nzDanger [disabled]="deleteConfirmationText !== 'DELETE'"
                                    (click)="confirmDelete()">
                                    Delete
                                </button>
                            </ng-template>
                        </nz-modal>
                        <!-- </span> -->

                   



                </div>
            </nz-spin>

            
        </div>
    </nz-card>

    <nz-card id="updateUserProfile" *ngIf="updateMode" class="margin-bottom: 0px">

        <nz-spin nzTip="Please wait..." [nzSpinning]="isLoading">
            <div nz-row nzGutter="16">
                <div nz-col class="gutter-row" nzSpan="24" style="text-align: right; width: 100%; height: 20px">
                    <a title="Cancel" (click)="this.checkFormState()" style="float: right; margin-bottom: 20px"><i
                            nz-icon nzType="close" theme="outline"></i></a>
                </div>
            </div>
            <!-- <div  class="form-container" [class.disabled]="isLoading"> -->
            <form nz-form nzLayout="vertical" *ngIf="userForm" [formGroup]="userForm">
                <div nz-row>
                    <!-- First name -->
                    <nz-form-item nz-col nzSpan="11">
                        <nz-form-label for="first_name" nzRequired>Name</nz-form-label>
                        <nz-form-control _ngcontent-jfp-c14=""
                            class="ng-tns-c16-67 ant-form-item-control-wrapper ng-star-inserted ant-col-24">
                            <div class="ant-form-item-control">
                                <span class="ant-form-item-children">
                                    <input _ngcontent-jfp-c14="" nz-input="" formControlName="first_name"
                                        placeholder="First Name" nzSize="medium"
                                        class="ant-input ng-untouched ng-pristine ng-invalid" />
                                    <span class="ant-form-item-children-icon">
                                        <span class="text-danger "
                                            *ngIf="userForm.get('first_name')?.errors?.['required'] && userForm.get('first_name')?.touched">Name is required.
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </nz-form-control>
                    </nz-form-item>
                    <div nz-col nzSpan="2">&nbsp;</div>
                    <!-- Last name -->
                    <!-- <nz-form-item nz-col nzSpan="11">
                        <nz-form-label for="last_name" nzRequired>Last Name</nz-form-label>
                        <nz-form-control _ngcontent-jfp-c14=""
                            class="ng-tns-c16-67 ant-form-item-control-wrapper ng-star-inserted ant-col-24">
                            <div class="ant-form-item-control">
                                <span class="ant-form-item-children">
                                    <input _ngcontent-jfp-c14="" nz-input="" formControlName="last_name"
                                        placeholder="Last Name" nzSize="medium"
                                        class="ant-input ng-untouched ng-pristine ng-invalid" />
                                </span>
                            </div>
                        </nz-form-control>
                    </nz-form-item> -->
                </div>

                <!-- User role -->
                <nz-form-item>
                    <nz-form-label for="roles" nzRequired> Roles</nz-form-label>
                    <nz-form-control>
                        <nz-select formControlName="roles" nzPlaceHolder="Please select" nzSize="small"
                            nzMode="multiple" style="height: auto!important;">
                            <nz-option *ngFor="let option of roleData" [nzLabel]="option.role_name"
                                [nzValue]="option.role_id">
                            </nz-option>
                        </nz-select>
                        <span class="ant-form-item-children-icon">
                            <span class="text-danger"
                                *ngIf="userForm.get('roles')?.errors?.['required'] && userForm.get('roles')?.touched">Roles are required.
                            </span>
                        </span>
                    </nz-form-control>
                </nz-form-item>

                <div nz-row>

                    <!-- Phone number (disabled) -->
                    <nz-form-item nz-col nzSpan="11">
                        <nz-form-label for="phone_number" nzRequired>Phone Number</nz-form-label>
                        <nz-form-control>
                            <input type="text" nz-input formControlName="phone_number" placeholder="Enter phone_number"
                                id="phone_number" required [disabled]="true">

                        </nz-form-control>
                    </nz-form-item>
                    <div nz-col nzSpan="2">&nbsp;</div>
                    <!-- Email (disabled) -->
                    <nz-form-item nz-col nzSpan="11">
                        <nz-form-label for="email" nzRequired>Email</nz-form-label>
                        <nz-form-control>
                            <input type="text" nz-input formControlName="email" placeholder="Email not available"
                                id="email" required [disabled]="true">

                        </nz-form-control>
                    </nz-form-item>
                </div>

            </form>

            <div nz-col nzSpan="24">

                <div style="
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                          ">
                    <div nz-col nzSpan="12">

                        <button *ngIf="updateMode" (click)="resetUpdateForm()" nz-button="" nztype="default"
                            class="ant-btn ant-btn-default" nz-wave="[object Object]">
                            <!----><span>Reset</span>
                        </button>
                    </div>

                    <div nz-col nzSpan="12" style="text-align: right">


                        <button nz-button="" nztype="default" class="cancelbtn-outline" (click)="this.checkFormState()"
                            [disabled]="isLoading">
                            <span>Cancel</span>
                        </button>

                        <button nz-button="" nztype="default" class="ant-btn ant-btn-primary m-l-10"
                            style="padding-left: 25px; padding-right: 25px" [disabled]="!this.userForm.dirty || this.userForm.invalid"
                            *ngIf="updateMode" [nzLoading]="isLoading" (click)="updateUserProfile()">
                            <span>Update</span>
                        </button>
                    </div>
                </div>
            </div>
        </nz-spin>

    </nz-card>
    
</div>